import React from 'react';
import { useTreatmentContext } from '../../../../Services/TreatmentContext';
import Modal from '../../../../Components/Modal/Modal';
import { Size } from '../../../../Enums/Size.enum';
import AssignPatientToWorkplace from './AssignPatientToWorkplace';

interface Props {
	isOpen: boolean;
	setIsOpen: (isOpen: boolean) => void;
	patientId: string;
}

const AssignPatientToWorkplaceModal: React.FC<Props> = ({
	isOpen,
	setIsOpen,
	patientId,
}) => {
	const { isCase } = useTreatmentContext();

	return (
		<Modal
			opened={isOpen}
			onClose={() => setIsOpen(false)}
			wrapChat={isCase}
			size={Size.MD}>
			<Modal.Header title='component.assignPatientToWorkplace.modalTitle' />
			<Modal.Content contentScroll>
				<AssignPatientToWorkplace
					patientId={patientId}
					onSuccess={() => setIsOpen(false)}
				/>
			</Modal.Content>
		</Modal>
	);
};

export default AssignPatientToWorkplaceModal;
